const getters = {
  user: (state) => state.user,
  keepAlive: (state) => state.app.keepAlive,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
};
export default getters;
